import {all, takeEvery, put, call } from 'redux-saga/effects';

import actions from "./actions"

import {
    getEcoDrivingGlobalSetting,
    getEcoDrivingScoreByIdApi,
    getEcoDrivingVehicleSetting
} from "../../services/ecodriving.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_ECO_DRIVING_DATA_BY_VEHICLE_ID(action: {payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getEcoDrivingScoreByIdApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_ECO_DRIVING_DATA_BY_VEHICLE_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/ecodriving/sagas/GET_ECO_DRIVING_DATA_BY_VEHICLE_ID", e); }
}

export function* GET_ECO_DRIVING_GLOBAL_SETTINGS(){
    try{
        const response: AxiosResponse<any> = yield call(
          getEcoDrivingGlobalSetting
        );
        if(response.data){
            yield put({
                type: actions.SET_ECO_DRIVING_GLOBAL_SETTINGS,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/ecodriving/sagas/GET_ECO_DRIVING_GLOBAL_SETTINGS", e); }
}

export function* GET_ECO_DRIVING_SETTING_BY_VEHICLE_ID(action: {payload: any, type:string}){
    try{
        const response: AxiosResponse<any> = yield call(
          getEcoDrivingVehicleSetting,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_ECO_DRIVING_SETTING_BY_VEHICLE_ID,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/ecodriving/sagas/GET_ECO_DRIVING_SETTING_BY_VEHICLE_ID", e); }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_ECO_DRIVING_DATA_BY_VEHICLE_ID, GET_ECO_DRIVING_DATA_BY_VEHICLE_ID),
        takeEvery(actions.GET_ECO_DRIVING_GLOBAL_SETTINGS, GET_ECO_DRIVING_GLOBAL_SETTINGS),
        takeEvery(actions.GET_ECO_DRIVING_SETTING_BY_VEHICLE_ID, GET_ECO_DRIVING_SETTING_BY_VEHICLE_ID)
    ])
}